import React, {Component} from 'react';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Loading from '../apa/components/Loading';
import BootstrapTable from 'react-bootstrap-table-next';
import NewInvoice from '../invoices/containers/NewInvoice';
import {invoiceListColumns} from '../invoices/InvoiceListColumns';
import { BaseUrl } from '../BaseUrl/BaseUrl';

const listColumns = [...invoiceListColumns]
listColumns.splice(1,1);

@connect(
	state => {
		return {
			customers: state.customers,
			auth: state.apa
		}
	},
	dispatch => {
		return {
			fetchCustomer: (customer_id, callback) => {
				dispatch(customers.fetchCustomer(customer_id, callback))
			}
		}
	}
)
export default class InvoiceList extends Component {


	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			customer: null
		};
	}

	componentDidMount() {
		const id = this.props.match.params.id;
		const headers = {
			Authorization: `Token ${this.props.auth.token}`,
			'Content-Type': 'application/json'
		};
		fetch(
			`${BaseUrl}/api/customers/${id}/invoices/`,
			{headers}
		)
			.then(res => res.json())
			.then(invoiceList =>
				{
					this.props.fetchCustomer(id, c => this.setState(
						{customer: c,
						invoiceList: invoiceList,
					isLoading: false
				}));
				}
			);
	}

	@autobind

	render() {
		const id = this.props.match.params.id;
		const invoiceList = this.state.invoiceList;

		if (this.state.isLoading)
			return <Loading/>;
		return (
			<DetailContainer id={id}>
				<h1>{this.state.customer.name}</h1>
				<NewInvoice customer={id}/>
				<BootstrapTable
					keyField='id'
					data={invoiceList}
					columns={listColumns}
				/>
				</DetailContainer>
		)
	}
}

